import React from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import LogsTable from './LogsTable';

const Logs = () => (
  <div>
    <Breadcrumbs
      aria-label="breadcrumb"
      sx={{
        marginBottom: '5px',
      }}
    >
      <Typography sx={{ color: 'text.primary' }}>Admin</Typography>
      <Typography sx={{ color: 'text.primary' }}>Logs</Typography>
    </Breadcrumbs>
    <LogsTable />
  </div>
  );

export default Logs;
